export class ImmunizationDataModel {
    vaccine: string;
    VaccineCode: string;
    Dosage: string;
    LastGiven: string;
    Doctor: string;
    VaccinationStatus: string;
    StatusClass: string;
    DueDate: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/immunization/immunizationdatamodel.ts